import { useEffect, useRef } from 'react'
import { UseFormReturn, FieldValues } from 'react-hook-form'

export function useAutoSubmit<T extends FieldValues>(
  form: UseFormReturn<T>,
  onSubmit: (data: T) => void | Promise<void>,
  delay: number = 500
) {
  const {
          register,
          handleSubmit,
          reset,
          control,
          setValue,
          watch,
          formState: { errors, isDirty, isValid },
      } = form

  const watchedValues = watch()
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    if (isValid && Object.keys(errors).length === 0 && isDirty === true) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
        timeoutRef.current = setTimeout(() => {
          handleSubmit(onSubmit)()
        }, delay)

    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [watchedValues, isValid, isDirty ])

}